import { IIconProps } from '../../typescript/interfaces/common.interface';

export default function TagLine(props: IIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='60.348 641.873 256.8438 90.982'
      width='256.844px'
      height='90.982px'
      {...props}>
      <path
        fill='#000'
        d='M106.132 669.689c-1.098.488-2.806 1.22-3.172 1.403-.549.305-1.159.976-1.159 2.379v5.734a2.344 2.344 0 0 1-2.38 2.379c-1.28 0-2.317-1.037-2.317-2.379v-31.171a2.317 2.317 0 0 1 2.318-2.318c1.342 0 2.379 1.037 2.379 2.318v9.577l3.172-1.464c.549-.244 1.159-.915 1.159-2.318v-6.527c0-2.928-2.318-5.368-5.246-5.429h-2.684c-3.05 0-5.49 2.44-5.49 5.429v32.696c0 2.989 2.44 5.429 5.49 5.429h2.684c2.928-.122 5.246-2.501 5.246-5.429zm28.707 10.98v-37.027c0-.732-.61-1.281-1.342-1.342h-3.05V685h10.492c1.403 0 2.074-.61 2.379-1.159.183-.366.915-2.074 1.403-3.172z'
        transform='matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -1.4210854715202004e-14, 0)'
      />

      <path
        fill='#fa9418'
        d='M176.856 685h-4.819l-3.843-29.402L164.351 685h-4.819l6.466-42.7h2.379c1.83 0 2.135 1.159 2.318 2.318z'
        transform='matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -1.4210854715202004e-14, 0)'
      />

      <path
        fill='#000'
        d='M213.735 642.3h-2.684c-1.586 0-1.891 1.342-1.952 1.525l-4.819 24.583-5.063-24.522s-.244-1.586-1.952-1.586h-2.684V685h4.331v-22.021l2.562 11.163c.244.915.732 3.477 3.294 3.477h1.342l3.294-14.64V685h4.331zm26.054-.427c-3.05 0-5.49 2.44-5.49 5.429v32.757c.061 2.928 2.501 5.368 5.49 5.368h3.355c2.928-.122 5.246-2.44 5.307-5.368v-32.757c0-2.928-2.379-5.307-5.307-5.429zm1.22 39.711c-1.281-.061-2.318-1.098-2.318-2.379v-31.11c0-1.281 1.037-2.318 2.318-2.379h.671c1.281 0 2.318 1.037 2.318 2.379v31.11c0 1.342-1.037 2.379-2.318 2.379zm43.53 3.416v-16.348s.122-3.172-1.586-4.026c1.769-.427 1.586-3.782 1.586-3.782v-13.176c0-2.989-2.44-5.368-5.368-5.368h-7.991V685h4.392v-18.361h2.318c1.159 0 2.257.671 2.257 2.745V685zm-8.967-22.509v-16.104h2.318c1.159 0 2.257.61 2.257 2.196v11.468c0 1.952-1.098 2.44-2.257 2.44z'
        transform='matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -1.4210854715202004e-14, 0)'
      />

      <text
        x='60.348'
        y='727.855'
        style={{
          fill: 'rgba(51, 51, 51, 0.98)',
          fontFamily: 'Arial, sans-serif',
          fontSize: '23px',
          fontWeight: 700,
          paintOrder: 'fill',
          whiteSpace: 'pre',
        }}
        transform='matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -1.4210854715202004e-14, 0)'>
        No Chaos … Only Food
      </text>
    </svg>
  );
}
